import GameContainer from "./GameContainer";

export default GameContainer;